import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import Map from '../Map/Map';
import './Contact.css'
import { Email, Facebook, Instagram, LocationOn, Phone } from '@mui/icons-material';
import { Typography } from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';

const Contact = () => {
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [email, setEmail] = useState('');
  const [level, setLevel] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!name || !number || !email || !level) {
      setError('Please fill out all fields.');
      return;
    } else {
      setError('');
    }
  
    const formData = {
       name,
       number,
       email,
       level,
    };
  
    const jsonData = JSON.stringify(formData);

    try {
      console.log(formData);
  
      const response = await axios.post('https://script.google.com/macros/s/AKfycbxOnf6yyRv-iyS8wsr8pdsaikOH_VZvP-7KPPyNmKLZ_yzLGahizjt3Ld3d8rXeabQFhg/exec', jsonData);
  
      if (response.status === 200 && response.data.status === 'success') {
        swal('Success', 'Form submitted successfully!', 'success');
        setName('');
        setNumber('');
        setEmail('');
        setLevel('');
      } else {
        throw new Error(response.data.message || 'Unknown error occurred');
      }
    } catch (error) {
      // Handle the error message properly for SweetAlert
      const errorMessage = error.response?.data?.message || error.message || 'Network Error';
      swal('Error', errorMessage, 'error');
      setError(`Failed to submit form: ${errorMessage}`);
    }
  };
  
  
  return (
    <Container id='Contact' style={{fontFamily: 'Roboto Slab, serif'}} fluid className='m-0 p-2 w-100'>
      <Container fluid className='m-0 p-2 flexs flex-wrap align-items-center justify-content-center content-container'>
        <div className="flexs flex-column bg-dark contact-info" style={{ borderRadius: '10px', borderBottomRightRadius: '0' }}>
          <Container className="contact-container flexs flex-column align-items-center p-4">
            <div className="contact-info bg-dark text-white p-4 rounded-start">
              <Typography variant="h5" className="text-center mb-3">
                <h3 className='text-white'>Contact Information</h3>
              </Typography>
              <Typography variant="body2" className="text-center text-muted mb-4">
                <del className='text-white' style={{fontFamily: 'Roboto Slab, serif'}}> Say something to start a live chat!</del>
              </Typography>
              <div className="contact-details">
                <div className="flexs align-items-center mb-3">
                  <Phone className="icon me-2" />
                  <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}}>+919495123689</Typography>
                </div>
                <div className="flexs align-items-center mb-3">
                  <Email className="icon me-2" />
                  <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}}>holyinstitutionstcr@gmail.com</Typography>
                </div>
                <div className="flexs align-items-center mb-3">
                  <LocationOn className="icon me-2" />
                  <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}}>Room-35 Lamer Complex, Post Office Road</Typography>
                </div>
              </div>
              <Map />
              <div className="social-icons flexs justify-content-center gap-3 mt-3">
                <a href="https://www.facebook.com/people/Hiljo-Joy/pfbid0Ywx5uifoADrj1Fit4BfZnsakxtFrBnzSPJvF4kYgdntZKHESCtmGcfoUQouPEbNFl/?ref=xav_ig_profile_web">
                  <Facebook className="social-icon" />
                </a>
                <a href="https://www.instagram.com/holyinstitution?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==">
                  <Instagram className="social-icon" />
                </a>
              </div>
            </div>
          </Container>
        </div>
        <div className="flexs flex-column text-center contact-form-container">
          <h2 className='text-dark text-center'>Contact Us</h2>
          <form onSubmit={handleSubmit} className="form flexs p-2 flex-column" style={{ border: '2px solid black', borderLeft: 'none', borderRadius: '10px', borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }}>
            <div className='flexs-all-col gap-3 p-2'>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className='w-100 mt-5'
                placeholder='Enter Your Full Name'
                style={{ border: '1px solid black', borderRadius: '10px', height: '50px' }}
              />
              <input
                type="number"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                className='w-100 my-3'
                placeholder='Enter Your Phone Number'
                style={{ border: '1px solid black', borderRadius: '10px', height: '50px' }}
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className='w-100 my-3'
                placeholder='Enter Your Email ID'
                style={{ border: '1px solid black', borderRadius: '10px', height: '50px' }}
              />
              <label htmlFor="level" className='text-center my-2' style={{ fontWeight: 'bolder' }}>Enter Your Level (German Language)</label>
              <input
                type="text"
                value={level}
                onChange={(e) => setLevel(e.target.value)}
                className='w-100'
                placeholder='e.g., Beginner or B1'
                style={{ border: '1px solid black', borderRadius: '10px', height: '50px' }}
              />
              {error && <p className='text-danger my-0'>{error}</p>}
              <button type="submit" className='bg-dark text-white cardhover' style={{ height: '50px', width: '120px', fontFamily: 'Roboto Slab, serif' }}>Send Now</button>
            </div>
          </form>
        </div>
      </Container>
      <Container fluid>
      </Container>
    </Container>
  );
};

export default Contact;
